import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { makeStyles } from '@material-ui/core/styles';
import Loading from 'components/common/Spin';
import Schools from 'modules/student/school/SchoolResearch';
import { API } from 'aws-amplify';
import Search from './SchoolResearch/Search';
import Button from 'components/common/Button';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ArrowRightIcon from '@material-ui/icons/ArrowForward';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import Pagination from '@material-ui/lab/Pagination';
import Dropdown from 'components/form/Dropdown';
import FormControl from '@material-ui/core/FormControl';
import Filters from './SchoolResearch/Filters';

const PageSizeOptions = [
  { label: 10, value: 10 },
  { label: 20, value: 20 },
  { label: 30, value: 30 },
  { label: 40, value: 40 },
];

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginRight: theme.spacing(2),
  },
  selectRoot: {
    backgroundColor: theme.palette.background['100'],
    borderRadius: 6,
    color: theme.palette.text.secondary,
  },
  select: {
    paddingLeft: 8,
    fontSize: '14px',
    fontWeight: 700,
  },
  item: {
    fontSize: 'inherit',
  },
}));

const Research = ({ student, addSchool, ...other }) => {
  const classes = useStyles();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    setLoading(true);
    fetchSchools();
  }, [page, query, limit, filters]);

  const fetchSchools = async () => {
    await API.get('api', '/college/search', {
      queryStringParameters: {
        'school.search': query,
        ...filters,
        fields:
          'id,school.name,school.city,school.state,latest.completion.consumer_rate,latest.programs,latest.cost,school.degrees_awarded.highest,school.ownership,school.locale,school.carnegie_size_setting,latest.student.size',
        per_page: limit,
        page,
      },
    }).then((res) => {
      const { results, metadata } = res;
      results.total = metadata.total;
      setData(results);
    }).finally(() => {
      setLoading(false);
    });
  };

  const onApplyFilter = (params) => {
    setPage(0);
    setFilters(params);
  }

  const handleSearch = (val) => {
    setQuery(val);
    page !== 0 && setPage(0);
  };

  const totalPages = Math.ceil(data ? data.total / limit : 0);

  return (
    <Box marginTop={5}>
      <Helmet title="Research" />
      <Grid container spacing={3}>
        <Grid item xs={12} md={5} lg={4}>
          <Filters onApplyFilter={onApplyFilter} />
        </Grid>
        <Grid item xs={12} md={7} lg={8}>
          <Search handleSearch={handleSearch} />
          <Loading linear spinning={loading} />
          {data?.length ? (
            <Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom={2}
              >
                {data && (
                  <Typography color="textSecondary" variant="smallBold">
                    {data.total} Results
                  </Typography>
                )}
                <Box display="flex" alignItems="center">
                  <Box paddingRight={1}>
                    <Typography color="textSecondary" variant="smallBold">
                      {`Show:`}
                    </Typography>
                  </Box>
                  <FormControl classes={{ root: classes.formControl }}>
                    <Dropdown
                      options={PageSizeOptions}
                      value={limit}
                      onChange={setLimit}
                    />
                  </FormControl>
                  <Pagination
                    size="small"
                    color="primary"
                    count={totalPages}
                    page={page +1}
                    onChange={(e, page) => setPage(page - 1)}
                  />
                </Box>
              </Box>
              <Loading spinning={loading || !data}>
                <Schools
                  student={student}
                  schools={data}
                  addSchool={addSchool}
                  {...other}
                />
              </Loading>
              {data?.length ? (
                <Box display="flex" justifyContent="space-between">
                  {page > 0 ? (
                    <Box marginTop={3}>
                      <Button
                        startIcon={<ArrowLeftIcon />}
                        onClick={() => setPage(page - 1)}
                      >
                        Prev
                      </Button>
                    </Box>
                  ) : (
                    <Box></Box>
                  )}
                  <Box marginTop={1}>
                    <Pagination
                      size="small"
                      color="primary"
                      count={totalPages}
                      page={page +1}
                      onChange={(e, page) => setPage(page - 1)}
                    />
                  </Box>
                </Box>
              ) : null}
            </Box>
          ) : (
            !loading && 'No Results'
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Research;
